<template>
  <Modal>
    <Modal.Title>
      <span class="flex items-center gap-2.5">
        <span
          class="flex size-[30px] items-center justify-center rounded-full bg-red-200/50"
        >
          <AlertIcon class="size-4 text-red-700" />
        </span>
        Cannot delete folder
      </span>
    </Modal.Title>
    <Modal.Body>
      You are not able to delete a folder that contains files. To delete this
      folder, please move the files outside of this folder.
    </Modal.Body>
    <Modal.Footer>
      <Button variant="primary" :size="isMobile ? 'lg' : 'md'" @click="close()">
        Okay
      </Button>
    </Modal.Footer>
  </Modal>
</template>

<script setup lang="ts">
import { Modal, Button, useModal } from '@dacr/library'
import { AlertIcon } from '@dacr/icons'
import { useDevice } from '@/shared/composables/useDevice'

const { close } = useModal()
const { isMobile } = useDevice()
</script>
